import { useState, useEffect, useRef } from "react";
import { FiMessageCircle, FiX } from "react-icons/fi";
import CustomerBot from "./Customerbot";

export default function FloatingBot() {
  const [open, setOpen] = useState(false);
  const [showTip, setShowTip] = useState(false);
  const panelRef = useRef(null);
  const buttonRef = useRef(null);

  // show the "Dhoorbin AI is here" bubble after 2s (until opened once)
  useEffect(() => {
    const seen = sessionStorage.getItem("botTipSeen");
    if (seen) return;
    const t = setTimeout(() => setShowTip(true), 2000);
    return () => clearTimeout(t);
  }, []);

  // close when clicking outside the panel / button
  useEffect(() => {
    if (!open) return;
    const onClick = (e) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    const onEsc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, [open]);

  const openChat = () => {
    setOpen(true);
    setShowTip(false);
    sessionStorage.setItem("botTipSeen", "1");
  };

  return (
    <>
      {/* CHAT PANEL */}
      {open && (
        <div
          ref={panelRef}
          className="fixed z-[9998] flex flex-col overflow-hidden bg-white shadow-2xl
                     inset-0 rounded-none
                     sm:inset-auto sm:bottom-24 sm:right-5 sm:w-[380px] sm:h-[600px]
                     sm:max-h-[calc(100vh-120px)] sm:rounded-2xl sm:border sm:border-gray-200
                     animate-[botIn_.2s_ease-out]"
        >
          {/* mobile close bar */}
          <div className="sm:hidden flex justify-end p-2 border-b border-gray-100">
            <button
              onClick={() => setOpen(false)}
              className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-600"
            >
              <FiX />
            </button>
          </div>

          {/* CustomerBot fills the panel (override its own height/border/radius) */}
          <div className="flex-1 min-h-0 [&>div]:!h-full [&>div]:!rounded-none [&>div]:!border-0 [&>div]:!shadow-none">
            <CustomerBot />
          </div>
        </div>
      )}

      {/* TOOLTIP */}
      {showTip && !open && (
        <div className="fixed z-[9998] bottom-[90px] right-5 max-w-[220px] animate-[botIn_.25s_ease-out]">
          <div className="relative bg-white shadow-lg rounded-2xl rounded-br-sm border border-gray-100 px-4 py-2.5">
            <button
              onClick={() => {
                setShowTip(false);
                sessionStorage.setItem("botTipSeen", "1");
              }}
              className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-gray-200 text-gray-600 text-[10px] flex items-center justify-center"
            >
              <FiX />
            </button>
            <p className="text-sm font-medium text-gray-800">
              Dhoorbin AI is here 👋
            </p>
            <p className="text-xs text-gray-500">Need help finding a hotel?</p>
          </div>
        </div>
      )}

      {/* FLOATING BUTTON */}
      <button
        ref={buttonRef}
        onClick={() => (open ? setOpen(false) : openChat())}
        aria-label="Open chat"
        className="fixed z-[9999] bottom-5 right-5 w-14 h-14 rounded-full shadow-xl text-white
                   bg-gradient-to-br from-blue-700 to-blue-900 flex items-center justify-center
                   hover:scale-105 active:scale-95 transition"
      >
        {!open && (
          <span className="absolute inset-0 rounded-full bg-blue-500/40 animate-ping" />
        )}
        <span className="relative">
          {open ? (
            <FiX className="text-2xl" />
          ) : (
            <FiMessageCircle className="text-2xl" />
          )}
        </span>
      </button>

      <style>{`
        @keyframes botIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
}
